module.exports = __webpack_public_path__ + "img/page-blank.6c7130af.png";